import { Suspense } from 'react'
import { CompanySwitcher as Content } from '@/components/layout/breadcrumbs/company-switcher/company-switcher'
import { CompanySwitcherFallback } from '@/components/layout/breadcrumbs/company-switcher/fallback'

export const CompanySwitcher = () => {
  return (
    <Suspense fallback={<CompanySwitcherFallback />}>
      <Content />
    </Suspense>
  )
}
